<template>
  <v-app id="dashboard">
    <navigation></navigation>

    <v-main class="grey lighten-3">
      <v-container>
        <v-row>
          <v-col>
            <v-sheet min-height="100%" outlined class="pa-6">

              <h3 class="mb-6">Beratern Produkte zuweisen</h3>

              <!-- table -->
              <div id="main">

                <!-- Bulk actions: applies to every member row below -->
                <v-sheet
                    class="bulk-actions-panel mb-4"
                    color="grey lighten-5"
                    rounded
                    elevation="0"
                    outlined
                >
                  <div class="bulk-actions-panel__intro d-flex align-start mb-2">
                    <v-icon color="grey darken-1" class="mr-2 mt-1" size="22">
                      mdi-account-group
                    </v-icon>
                    <div class="text-subtitle-2 font-weight-medium grey--text text--darken-3">
                      Sammelaktionen (alle Mitglieder)
                    </div>
                  </div>

                  <!-- gleiche Spaltenaufteilung wie Mitgliedszeilen (Vuetify-Row-Gutter) -->
                  <v-row class="assign-grid-bulk align-end ma-0">
                    <v-col cols="3" class="assign-col assign-col-member py-2">
                      <v-tooltip bottom max-width="280">
                        <template #activator="{ on, attrs }">
                          <v-btn
                              v-bind="attrs"
                              v-on="on"
                              small
                              outlined
                              color="primary"
                              block
                              aria-label="Alle Zuweisungen entfernen: hebt für alle Mitglieder alle Produktzuweisungen auf."
                              @click="removeAllWork()"
                          >
                            Alle Zuweisungen entfernen
                          </v-btn>
                        </template>
                        <span>
                          Hebt für <strong>alle</strong> Mitglieder in dieser Liste sämtliche Produktzuweisungen
                          (Produkt 1, 2 und 3) auf.
                        </span>
                      </v-tooltip>
                    </v-col>

                    <v-col cols="3" class="assign-col assign-col-p1 py-2">
                      <div class="assign-col-heading text-caption font-weight-medium">Produkt 1</div>
                      <div class="text-caption text--secondary mb-1">Setzt diese Spalte für alle Zeilen.</div>
                      <v-select
                          dense
                          hide-details
                          clearable
                          placeholder="Produkt wählen …"
                          :items="workOptions"
                          item-text="label"
                          item-value="id"
                          @change="assignBulk(1, $event)"
                      />
                    </v-col>

                    <v-col cols="3" class="assign-col assign-col-p2 py-2">
                      <div class="assign-col-heading text-caption font-weight-medium">Produkt 2</div>
                      <div class="text-caption text--secondary mb-1">Setzt diese Spalte für alle Zeilen.</div>
                      <v-select
                          dense
                          hide-details
                          clearable
                          placeholder="Produkt wählen …"
                          :items="workOptions"
                          item-text="label"
                          item-value="id"
                          @change="assignBulk(2, $event)"
                      />
                    </v-col>

                    <v-col cols="3" class="assign-col assign-col-p3 py-2">
                      <div class="assign-col-heading text-caption font-weight-medium">Produkt 3</div>
                      <div class="text-caption text--secondary mb-1">Setzt diese Spalte für alle Zeilen.</div>
                      <v-select
                          dense
                          hide-details
                          clearable
                          placeholder="Produkt wählen …"
                          :items="workOptions"
                          item-text="label"
                          item-value="id"
                          @change="assignBulk(3, $event)"
                      />
                    </v-col>
                  </v-row>
                </v-sheet>

                <!-- ROWS -->
                <v-row
                    v-for="member in members"
                    :key="member.id"
                    class="assign-grid-row align-center py-2"
                >

                  <!-- name -->
                  <v-col cols="3" class="assign-col assign-col-member">
                    <div class="d-flex align-center">
                      <v-avatar size="32" class="mr-2 flex-shrink-0">
                        <img :src="getAvatar(member.name)" alt=""/>
                      </v-avatar>
                      <span class="text-truncate">{{ member.name }}</span>
                      <div class="d-flex align-center ml-auto flex-shrink-0">
                        <v-btn
                            x-small
                            :href="profileUrl(member.code)"
                            target="_blank"
                            style="min-width: 26px"
                        >
                          <img
                              src="arrow-up-right-from-square-solid-full.svg"
                              style="width: 14px"
                          />
                        </v-btn>
                        <v-btn
                            x-small
                            @click="openQrModal(member.code)"
                            style="min-width: 26px"
                        >
                          <img
                              src="qrcode-solid-full.svg"
                              style="width: 14px"
                          />
                        </v-btn>
                      </div>
                    </div>
                  </v-col>

                  <!-- slots -->
                  <v-col
                      v-for="pos in [1,2,3]"
                      :key="pos"
                      cols="3"
                      :class="['assign-col', 'assign-col-p' + pos]"
                  >
                    <v-select
                        v-if="slotValuesMap[member.id]"
                        dense
                        hide-details
                        clearable
                        :items="workOptions"
                        item-text="label"
                        item-value="id"
                        v-model="slotValuesMap[member.id][pos]"
                        @change="onSlotChange(member, pos, $event)"
                    />
                  </v-col>

                </v-row>
              </div>

              <!-- end of table -->

            </v-sheet>
          </v-col>
        </v-row>

        <!-- Snackbar -->
        <v-snackbar
            v-model="snackbar.show"
            :timeout="snackbar.timeout"
            :color="snackbar.color"
            top
            right
        >
          {{ snackbar.text }}
          <v-btn text @click="snackbar.show = false">Schließen</v-btn>
        </v-snackbar>

        <!-- QR modal -->
        <v-dialog v-model="qrModal.show" max-width="300">
          <v-card>
            <v-card-title>QR-Code</v-card-title>
            <v-card-text class="text-center">
              <v-img
                  v-if="qrModal.image"
                  :src="qrModal.image"
                  max-width="250"
              />
              <span v-else>Wird geladen …</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="qrModal.show = false">Schließen</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
#main table td {
  padding-left: 0;
  padding-right: 0;
}

.checkbox-wrap {
  width: 30px;
  margin-left: auto;
  margin-right: auto;
}

#main .v-row {
  border-bottom: 1px solid #eee;
}

#main .bulk-actions-panel {
  border-left: 4px solid #757575 !important;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 0;
  padding-right: 0;
  overflow: hidden;
  /* wie v-row: gleicher Außenrand wie die Mitgliedszeilen darunter */
  margin-left: -12px;
  margin-right: -12px;
  width: calc(100% + 24px);
  max-width: none;
  box-sizing: border-box;
}

#main .bulk-actions-panel__intro {
  /* bündig mit horizontalem Zellpadding der Spalten (12px) */
  padding-left: 12px;
  padding-right: 12px;
}

#main .bulk-actions-panel .assign-grid-bulk {
  border-bottom: none;
}

/* Eine helle Fläche für alle Tabellenspalten (wie grey lighten-5) */
#main .assign-col-member,
#main .assign-col-p1,
#main .assign-col-p2,
#main .assign-col-p3 {
  background-color: #fafafa;
}

#main .assign-col-heading {
  color: rgba(0, 0, 0, 0.75);
  line-height: 1.25;
}
</style>

<script>
import Navigation from "./Navigation.vue";

export default {
  components: {Navigation},

  data: () => ({
    page: 1,
    token: null,
    selectedUserIds: [],
    selectAll: false,
    slotValuesMap: {}, // key = member.id, value = {1:id, 2:id, 3:id}
    qrModal: {
      show: false,
      image: null,
    },
    snackbar: {
      show: false,
      text: '',
      color: 'success',
      timeout: 3000,
    },
  }),

  computed: {
    members() {
      const data = this.$store.getters.team_member_work || [];

      return data.map(member => {
        const slots = this.getWorkSlots(member.works);

        return {
          ...member, // copy
          slotValues: {
            1: slots[1]?.parent_id || slots[1]?.id || null,
            2: slots[2]?.parent_id || slots[2]?.id || null,
            3: slots[3]?.parent_id || slots[3]?.id || null,
          }
        };
      });
    },

    works() {
      return this.$store.getters.works;
    },

    // formatted dropdown options
    workOptions() {
      return (this.works?.data || [])
          .filter(w => w.status === 'PUBLIC')
          .map(w => ({
            ...w,
            label: w.internal_name ?? w.name
          }));
    }
  },

  async mounted() {
    if(localStorage.getItem('marketing')==='0') {
      this.$router.push({name: "dashboard"});
      return ;
    }
    this.fetchMemberWork();
    this.fetchWorks(1);
    this.getToken();
  },

  methods: {

    async assignBulk(position, workId) {

      const allUsers = this.members.map(m => m.id);

      if (!workId) return;

      const res = await this.$store.dispatch("marketingAssignWork", {
        user_ids: allUsers,
        work_id: workId,
        position: position
      });

      if (res.data.success) {
        this.showToast(`Produkt ${position} für alle zugewiesen`);
      } else {
        this.showToast('Sammelzuweisung fehlgeschlagen', 'error');
      }

      this.fetchMemberWork();
    },

    getWorkSlots(works) {
      const slots = {1: null, 2: null, 3: null};

      works.forEach(work => {
        if (work.position >= 1 && work.position <= 3) {
          slots[work.position] = work;
        }
      });

      return slots;
    },

    async fetchMemberWork() {
      await this.$store.dispatch("getTeamMemberWork");

      const members = this.$store.getters.team_member_work || [];

      members.forEach(member => {
        const slots = this.getWorkSlots(member.works);
        this.$set(this.slotValuesMap, member.id, {
          1: slots[1]?.parent_id || slots[1]?.id || null,
          2: slots[2]?.parent_id || slots[2]?.id || null,
          3: slots[3]?.parent_id || slots[3]?.id || null,
        });
      });
    },

    async fetchWorks(page = 1) {
      this.page = page;
      window.scrollTo(0, 0);
      await this.$store.dispatch("getWorks", page);
    },

    async onSlotChange(member, position, workId) {
      const existing = this.getWorkSlots(member.works)[position];

      // remove old
      if (existing) {
        await this.$store.dispatch("marketingUnassignWork", {
          work_id: existing.id,
          user_id: member.id
        });
      }

      // assign new
      if (workId) {
        const res = await this.$store.dispatch("marketingAssignWork", {
          user_ids: [member.id],
          work_id: workId,
          position: position
        });

        if (res.data.success) {
          this.showToast('Produkt zugewiesen');
        } else {
          this.showToast('Zuweisung fehlgeschlagen', 'error');
        }
      }

      this.fetchMemberWork();
    },

    async removeAllWork() {

      const selectedUserIds = this.members.map(m => m.id);

      const res = await this.$store.dispatch("marketingUnassignAllWork", {
        user_ids: selectedUserIds
      });

      if (res.data.success) {
        this.showToast('Alle Zuweisungen entfernt');
      } else {
        this.showToast('Entfernen fehlgeschlagen', 'error');
      }

      this.fetchMemberWork();
    },

    getAvatar(name) {
      const firstName = name.split(' ')[0];
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(firstName)}&background=random&size=64`;
    },

    showToast(message, color = 'success') {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },

    profileUrl(code) {
      return process.env.VUE_APP_PUBLIC_URL + `profile/${code}?&token=` + this.token;
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedUserIds = this.members.map(m => m.id);
      } else {
        this.selectedUserIds = [];
      }
    },

    async openQrModal(userCode) {
      this.qrModal.show = true;
      this.qrModal.image = null;

      try {
        const res = await fetch(process.env.VUE_APP_PUBLIC_URL + `user-qr/${userCode}/${this.token}`);
        const data = await res.text(); // <-- read as plain text
        this.qrModal.image = data;     // assign directly
      } catch (e) {
        this.showToast('QR-Code konnte nicht geladen werden', 'error');
        console.log(e);
        this.qrModal.show = false;
      }
    },

    async getToken() {
      const res = await this.$store.dispatch("getToken");
      this.token = res.data;
    }

  },

  watch: {
    selectedUserIds(newVal) {
      this.selectAll = newVal.length === this.members.length;
    }
  }
};
</script>
